import React from "react";

export const BookMarkIconFilled = () => {
  return (
    <svg
      width="28"
      height="36"
      viewBox="0 0 28 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.621 21.6057L14.0002 18.9614L18.3793 21.6057L17.209 16.6099L21.0757 13.2766L16.0075 12.8479L14.0002 8.14426L11.9929 12.8479L6.92464 13.2766L10.7913 16.6099L9.621 21.6057ZM0.458496 35.1875V4.0578C0.458496 3.00537 0.82308 2.11457 1.55225 1.38541C2.28141 0.65624 3.17221 0.291656 4.22464 0.291656H23.7757C24.8281 0.291656 25.7189 0.65624 26.4481 1.38541C27.1772 2.11457 27.5418 3.00537 27.5418 4.0578V35.1875L14.0002 29.3781L0.458496 35.1875Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};

export const BookMarkIcon = () => {
  return (
    <svg
      width="28"
      height="36"
      viewBox="0 0 28 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.621 21.6057L14.0002 18.9614L18.3793 21.6057L17.209 16.6099L21.0757 13.2766L16.0075 12.8479L14.0002 8.14426L11.9929 12.8479L6.92464 13.2766L10.7913 16.6099L9.621 21.6057ZM0.458496 35.1875V4.0578C0.458496 3.00537 0.82308 2.11457 1.55225 1.38541C2.28141 0.65624 3.17221 0.291656 4.22464 0.291656H23.7757C24.8281 0.291656 25.7189 0.65624 26.4481 1.38541C27.1772 2.11457 27.5418 3.00537 27.5418 4.0578V35.1875L14.0002 29.3781L0.458496 35.1875ZM3.5835 30.3958L14.0002 25.9167L24.4168 30.3958V4.0578C24.4168 3.89739 24.35 3.75051 24.2163 3.61718C24.083 3.4835 23.9361 3.41666 23.7757 3.41666H4.22464C4.06423 3.41666 3.91735 3.4835 3.78402 3.61718C3.65034 3.75051 3.5835 3.89739 3.5835 4.0578V30.3958Z"
        fill="#1C1B1F"
      />
    </svg>
  );
};
